import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import Content1 from "../components/Content1";

const IndustrialTee = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Navigation Bar */}
      <NavbarThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Industrial Tee"} />

      {/* Content */}
      <Content1 pageName="Industrial Tee" />

      {/* Footer */}
      <FooterThree />
    </>
  );
};

export default IndustrialTee;
